import { all, put, select, takeEvery } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { PapiRequestDaDeviationWho, PapiDaDeviationWho } from '@wix/da-papi-types';
import { withOffset, selectors } from '../../Stream';
import { initializeIfNeeded } from '../../Stream/base/actions';
import { fetchStreamContents, takeStreamFetch } from '../../Stream/helpers';
import { StreamType } from '../../Stream/types';
import { UserStreamParams } from './types';
import { fetchNextUsers, initializeUserStream } from './actions';
import { streamType } from './constants';

const logger = ddt.createLogger('userlist');

function* handleFetchUsers({ payload: { streamId } }: ReturnType<typeof fetchNextUsers>) {
  const {
    offset,
    limit,
    streamParams,
  }: {
    offset: ReturnType<typeof withOffset.selectors.getNextOffset>;
    limit: ReturnType<typeof selectors.getItemsPerFetch>;
    streamParams: UserStreamParams;
  } = yield select(state => ({
    streamParams: selectors.getStreamParams(state, streamId),
    offset: withOffset.selectors.getNextOffset(state, streamId),
    limit: selectors.getItemsPerFetch(state, streamId),
  }));

  if (!streamParams || streamParams.type !== streamType) {
    return;
  }

  yield fetchStreamContents<PapiRequestDaDeviationWho, PapiDaDeviationWho>({
    streamId,
    url: 'who',
    papiProject: 'dadeviation',
    params: {
      deviationid: streamParams.deviationId,
      type: streamParams.streamType,
      offset,
      limit,
    },
    getStreamData: result => ({
      hasMore: result.hasMore || false,
      items: result.results || [],
      total: result.total,
      nextOffset: result.nextOffset,
    }),
    fakeResponse: () => {
      return {
        hasMore: true,
        results: [],
        total: 0,
        nextOffset: 0,
      };
    },
  });
}

function* handleInitialize({
  payload: { deviationId, streamId, type },
}: ReturnType<typeof initializeUserStream>) {
  logger.log('Initializing user stream', deviationId, type);

  const streamParams: UserStreamParams = {
    type: streamType,
    deviationId,
    streamType: type,
  };

  // This can be called many many times and only init and fetch when really needed
  yield put(
    initializeIfNeeded(streamId, {
      streamType: StreamType.WITH_OFFSET,
      autoFetch: true,
      streamParams,
      itemsPerFetch: 24,
      hasMore: true,
      items: [],
      fetchNextCallback: fetchNextUsers,
    })
  );
}

export default function* userRootSaga() {
  yield all([
    takeEvery(initializeUserStream, handleInitialize),
    takeStreamFetch(fetchNextUsers, handleFetchUsers),
  ]);
}
